import { Trans } from "@lingui/react/macro";
import { Alert, AlertDescription, AlertTitle } from "@mindstonehq/ui";

/**
 * Shown in place of the lesson media player when the browser could not play
 * the source. Keeps the learner oriented (the transcript and the rest of the
 * page keep working) and gives them the one thing that usually helps: the
 * source itself, in a new tab.
 */
export function MediaErrorPanel({
  mediaType,
  sourceHref,
}: {
  mediaType: "video" | "audio";
  /** The playable source; opened in a new tab. Omit when there is none. */
  sourceHref?: string;
}) {
  return (
    <Alert variant="destructive" className="max-w-3xl mx-auto">
      <AlertTitle>
        {mediaType === "video" ? (
          <Trans>This video can&apos;t be played right now.</Trans>
        ) : (
          <Trans>This audio can&apos;t be played right now.</Trans>
        )}
      </AlertTitle>
      <AlertDescription>
        <Trans>Try again in a moment.</Trans>{" "}
        {sourceHref ? (
          <a
            href={sourceHref}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2"
          >
            <Trans>Open the source in a new tab</Trans>
          </a>
        ) : null}
      </AlertDescription>
    </Alert>
  );
}
